import { FC } from 'react';
import { Navigate, useOutletContext } from 'react-router';

import { SelfServiceError } from '../../helpers/Errors';
import { SupportedErrorTypes } from '../../services/ErrorService';
import { TicketOutletContext } from '../../services/LoaderService';
import { calculateInitialPage } from '../../services/RouteService';

const InitialPageNavigator: FC = () => {
  const outletContext = useOutletContext<TicketOutletContext>();
  const initialPage = calculateInitialPage({
    ticket: outletContext.ticket,
  });

  if (initialPage) {
    return <Navigate to={initialPage} />;
  }

  throw new SelfServiceError({
    reason: SupportedErrorTypes.unexpectedError,
    stylesheet: outletContext.globalStylesheet,
    ticket: outletContext.ticket,
  });
};

export default InitialPageNavigator;
